<template>
  <div class="tags" :class="{ leftWidth10: +leftWidth == 10 }">
    <span
      v-show="tagsList"
      v-for="obj in tagsList"
      :key="obj"
      v-text="obj"
      :class="[
        'small-tag',
        {
          d2: obj === '2D',
          d3: obj === '3D',
          imax3d: obj === 'IMAX3D'
        }
      ]"
    ></span>
  </div>
</template>

<script>
/**
 * 组件说明：影厅类型标签
 */
export default {
  name: 'tags',
  props: {
    tagsList: null,
    leftWidth: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.tags {
  display: flex;
  line-height: 1;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5px;
  .small-tag {
    font-weight: normal;
    font-family: PingFangSC-Regular;
    padding: 0px 4px;
    border-radius: 5px;
    color: #fff;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    // background: #31ce44;
    background: #f0aeab;
    margin-left: 5px;
    // margin-right: 10px;
    max-width: 250px;
    &.d2 {
      // background-color: #31ce44;
      background: #f0aeab;
    }
    &.d3 {
      // background-color: #57a3f8;
      background: #f0aeab;
    }
    &.imax3d {
      // background-color: #14b8db;
      background: #f0aeab;
    }
  }
}
.leftWidth10 {
  margin-left: 10px;
  .small-tag {
    margin-left: 10px;
  }
}
</style>
